<template>
  <div class="b-unchanged-itm">
    <span class="b-unchanged-itm-content">{{ content }}</span>
    <BTooltip
      v-if="helpContent"
      bottom
    >
      <BIcon
        size="small"
        class="b-unchanged-itm-icon"
      >
        help
      </BIcon>
      <template #content>
        <span>{{ helpContent }}</span>
      </template>
    </BTooltip>
  </div>
</template>

<script lang="ts" setup>
type TProps = {
  content: string;
  helpContent?: string;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.b-unchanged-itm {
  margin: 2px;
  
  &-content {
    display: inline-block;
    width: 80%;
    position: relative;
    background-color: #F5F7FA;
    padding: 8px 16px;
    margin-right: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &-icon {
    margin-bottom: 16px;
  }
}
</style>
